export enum IndicatorEsbStatusEnum {
	Finished = 1,
	Pending = 2,
	Lost = 3,
}
